module.exports = __webpack_public_path__ + "assets/images/04_d0b10214e1cde8eff15a5b87f0361ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/04.png
// module id = 181
// module chunks = 0